import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { initValueContact } from '../../shared/initials';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import apiServices from '../../services/service';
import { isLoadingByKey } from '../../shared/controls/methods/getLoadingState';
import { fetchDataAndUpdateStore, singleRowAddUpdateInStore } from '../../redux/actions';
import { getGridDataByModuleKey, getUser } from '../../redux/selector';
import { validationSchemaContact } from './validationSchema';
import ContactForm from './contactForm';
import HeaderProfileBlock from '../sharedChild/headerImage/headerProfileBlock';
import { contactInputData, dropdownPayload } from '../../shared/constants';

const AddContactsForm = ({}) => {
  const contactData = initValueContact;
  const stateData = useSelector((state) => state);
  const dispatch = useDispatch();
  let storeLoading = isLoadingByKey(
    stateData,
    'leadSourceList',
    'salutation',
    'contactPersonRole',
    'owner'
  );

  const navigate = useNavigate();
  const location = useLocation();
  const userInfo = useSelector(getUser);
  // Update owner in initValueLead if it is an empty string
  if (!contactData.owner) {
    contactData.owner = userInfo?.user?.display_name;
    contactData.ownerId = userInfo?.user?.userId;
  }
  const [formData, setFormData] = useState(contactData);
  const [errormsg, setErrorMsg] = useState({});
  const [formEdited, setFormEdited] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState({});
  const [loading, setLoading] = useState(storeLoading);
  const [imagefile, setImageFile] = useState(null);
  const gridData = useSelector(getGridDataByModuleKey('contactList'));

  const handleChangeForm = (e) => {
    const { name, value } = e.target;

    // Restrict input for specific fields
    let convertedValue = value;
    if (['phone', 'mobile', 'assistantPhone'].includes(name)) {
      // Allow only numbers, +, and -
      convertedValue = value.replace(/[^0-9+\-() ]/g, '');
    }

    // Clear the error message for the field being edited
    setErrorMsg((prevErrorMsg) => ({
      ...prevErrorMsg,
      [name]: undefined,
    }));

    // Update form data
    setFormData({
      ...formData,
      [name]: convertedValue,
    });

    setFormEdited(true);
  };

  const handleChangeCheckbox = (e) => {
    const { name, checked } = e.target; // Use 'checked' for true/false value
    setErrorMsg((prevErrorMsg) => ({
      ...prevErrorMsg,
      [name]: undefined,
    }));
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: checked, // Set the checkbox state as true/false
    }));
    setFormEdited(true);
  };

  const handleSubmit = async (formData) => {
    try {
      // Remove "https://" and "www." from relevant fields
      const sanitizedData = {
        ...formData,
        facebook: formData?.facebook?.replace(/^(https?:\/\/)?(www\.)?/, ''), // Remove protocol and www from contactLinkedIn
        twitter: formData?.twitter?.replace(/^(https?:\/\/)?(www\.)?/, ''), // Remove protocol and www from companyLinkedIn
      };

      await validationSchemaContact.validate(sanitizedData, {
        abortEarly: false,
      });
      handleFormSubmit(sanitizedData);
    } catch (error) {
      const fieldErrors = {};
      error?.inner?.forEach((err) => {
        fieldErrors[err.path] = err.message;
      });
      setErrorMsg(fieldErrors);
      console.error('Validation Error:', fieldErrors);
    }
  };

  const handleChange = (selectedOption, name) => {
    setSelectedOptions((prevState) => ({
      ...prevState,
      [name]: selectedOption,
    }));

    handleLookupDropDownChange(selectedOption.value, selectedOption, name);
  };

  const handleLookupDropDownChange = (selectedId, selectedOption, name) => {
    const selectedValue = selectedOption.label;
    setErrorMsg((prevErrorMsg) => ({
      ...prevErrorMsg,
      [name]: undefined,
    }));
    if (name === 'leadSourceId') {
      setFormData({
        ...formData,
        leadSourceId: selectedId,
        leadSource: selectedValue,
      });
      setFormEdited(true);
    } else if (name === 'salutationId') {
      setFormData({
        ...formData,
        salutationId: selectedId,
        salutation: selectedValue,
      });
      setFormEdited(true);
    } else if (name === 'contactPersonRoleId') {
      setFormData({
        ...formData,
        contactPersonRoleId: selectedId,
        contactPersonRole: selectedValue,
      });
      setFormEdited(true);
    } else if (name === 'accountId') {
      setFormData({
        ...formData,
        accountId: selectedId,
        account: selectedValue,
      });
      setFormEdited(true);
    } else if (name === 'ownerId') {
      setFormData({
        ...formData,
        ownerId: selectedId,
        owner: selectedValue,
      });
      setFormEdited(true);
    }
  };

  const handleCloseAddForm = () => {
    navigate('/contacts');
  };

  const updateList = async (msg, id) => {
    // setLoading(false);
    toast.success(msg, {
      position: 'top-right',
    });

    try {
      // ✅ Await the dispatch before navigation
      // await dispatch(
      //   fetchDataAndUpdateStore({
      //     key: "contactList",
      //     inputData: contactInputData,
      //   })
      // );
      dispatch(
        singleRowAddUpdateInStore({
          moduleName: 'Contact',
          id: formData.type === 'add' ? id : formData.id,
          rowIndex: formData.rowIndex,
        })
      );
      dispatch(
        fetchDataAndUpdateStore({
          key: 'contactDropdown',
          inputData: dropdownPayload,
        })
      );
      if (formData.from === 'view') {
        navigate(
          `/contacts/viewContact?id=${formData.id}&pageNo=${gridData?.inputPayload?.pageNumber}`
        );
      } else {
        navigate('/contacts');
      }
    } catch (error) {
      console.error('Failed to fetch and update Contact:', error);
      toast.error('Something went wrong while updating the list.', {
        position: 'top-right',
      });
    }
  };

  const handleUploadImage = async (imagefile) => {
    setImageFile(imagefile);
    setFormEdited(true);
  };

  const saveUploadImage = async (id) => {
    if (imagefile && id) {
      const newFile = new File([imagefile], id.data, {
        type: imagefile.type,
      });
    }
  };

  const editUploadImage = async (id) => {
    if (imagefile && id) {
      const newFile = new File([imagefile], id, {
        type: imagefile.type,
      });
    }
  };

  const handleFormSubmit = (formData) => {
    if (formData.type === 'add') {
      setLoading(true);

      apiServices
        .createContactList(formData)
        .then((response) => {
          if (response.status === 200) {
            const id = response.data;
            updateList('Contact created successfully!', id);
            saveUploadImage(response);
            setLoading(false);
          } else {
            setLoading(false);
            const errorMessages = [];
            for (const key in response.errors) {
              if (response.errors.hasOwnProperty(key)) {
                const messages = response.errors[key];
                errorMessages.push(...messages);
              }
            }
            errorMessages.forEach((errorMessage) => {
              toast.error(errorMessage, { position: 'top-right' });
            });
          }
        })

        .catch((error) => {
          console.error('Error:', error, 'DataFormat:', formData);
          toast.error('An unexpected error occurred.', {
            position: 'top-right',
          });
          setLoading(false);
        });
    } else {
      setLoading(true);
      editUploadImage(formData.id);
      apiServices
        .updateContactList(formData)
        .then((response) => {
          if (response.status === 200) {
            updateList('Contact updated successfully!');

            setLoading(false);
          } else {
            setLoading(false);
            const errorMessages = [];
            for (const key in response.errors) {
              if (response.errors.hasOwnProperty(key)) {
                const messages = response.errors[key];
                errorMessages.push(...messages);
              }
            }
            errorMessages.forEach((errorMessage) => {
              toast.error(errorMessage, { position: 'top-right' });
            });
          }
        })

        .catch((error) => {
          console.error('Error:', error, 'DataFormat:', formData);
          toast.error('An unexpected error occurred.', {
            position: 'top-right',
          });
          setLoading(false);
        });
    }
  };

  useEffect(() => {
    setLoading(storeLoading);
  }, [storeLoading]);

  useEffect(() => {
    let updatedFormData = {
      ...formData,
      type: location.pathname.includes('addContact') ? 'add' : 'edit',
    };
    if (location.pathname.includes('editContact') && location.state) {
      updatedFormData = {
        ...location.state,
        type: 'edit',
      };
    }
    setFormData(updatedFormData);
  }, [location]);

  return (
    <div className="addlead_container">
      <div className="viewHeader viewshadow">
        <HeaderProfileBlock
          localData={formData}
          moduleName={'Contact'}
          uploadFile={handleUploadImage}
        />

        <div className="rightAction">
          <button
            type="button"
            className="btn btn-outline-primary"
            data-bs-dismiss="modal"
            onClick={handleCloseAddForm}
          >
            Cancel
          </button>
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => {
              handleSubmit(formData);
            }}
            disabled={loading || (formData.type === 'edit' && !formEdited)}
          >
            {loading && (
              <>
                {' '}
                <div className="spinner-border spinner-border-sm me-2" role="status"></div>
              </>
            )}
            {loading ? 'Loading...' : 'Save'}
          </button>
        </div>
      </div>
      <ContactForm
        formData={formData}
        selectedOptions={selectedOptions}
        handleSubmit={handleSubmit}
        handleChangeForm={handleChangeForm}
        handleChangeCheckbox={handleChangeCheckbox}
        handleChange={handleChange}
        errormsg={errormsg}
      />
    </div>
  );
};

export default AddContactsForm;
